import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Form, Modal } from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { setLinkAbhaClicked, setLinkMoreDocsToAbha } from '../../../store/actions/claimDetailsAction';
import { resetLinkRecords, updateFileList } from '../../../store/actions/linkContextAction';
import { EDIT_RECORD, LINK_RECORDS_COMPONENTS, LINK_RECORDS_COMPONENTS_CLAIMS_DATA } from '../abdmConstants';

const LinkRecordsModal = ({ setVisible, visible, isEdit = false, selectedRecord = {} }: any): ReactElement => {
  const { linkAbhaClick } = useSelector((state: RootState): any => state?.admissionDetails || {});
  const [currIndex, setCurrIndex] = useState(0);
  const [abhaForm] = Form.useForm();
  const dispatch = useDispatch();
  const [componentNav, setComponentNav] = useState(isEdit ? EDIT_RECORD || [] :
    linkAbhaClick ? LINK_RECORDS_COMPONENTS_CLAIMS_DATA : LINK_RECORDS_COMPONENTS);
  const goNext = (toTab?: number): any => {
    if (toTab !== null || toTab !== undefined) {
      switch (true) {
        case (toTab === -1):
          abhaForm.resetFields();
          dispatch(resetLinkRecords());
          setCurrIndex(0);
          dispatch(setLinkAbhaClicked(false));
          dispatch(setLinkMoreDocsToAbha(false));
          setVisible(false);
          break;
        case (toTab !== -1):
          gotoIndex(toTab);
      }
    } else {
      gotoIndex();
    }
  };

  const gotoIndex = (index?: number): void => {
    if (componentNav[index !== undefined ? index : currIndex + 1]) {
      setCurrIndex(index !== undefined ? index : currIndex + 1);
    } else {
      setCurrIndex(currIndex);
    }
  };
  const { component: AbhaComponent, title, backFn }: any = componentNav[currIndex];

  const onBackPress = (): any => {
    // abhaForm.resetFields();
    if (componentNav[currIndex - 1]) {
      setCurrIndex(currIndex - 1);
    } else {
      setCurrIndex(currIndex);
    }
  };

  useEffect ((): any => {
    if (isEdit) {
      let recordedFilesObj: any = {};
      selectedRecord?.linkedHiType?.forEach((item: any): any => {
        let tempObj: any = [];
        if (recordedFilesObj?.[item?.hiType]) {
          tempObj = [...recordedFilesObj?.[item.hiType]];
        }
        recordedFilesObj = {
          ...recordedFilesObj,
          [item.hiType] : [ ...tempObj, {name: item?.documentName, id: item?.id, linked: item?.linked, response: {
            uploadedDetails: [{fileGuid: item?.documentId }]}}],
        };
      });
      dispatch(updateFileList(recordedFilesObj));
    }
  }, []);

  return (
    <Modal
      centered={true}
      visible={visible}
      onCancel={(): any => goNext(-1)}
      footer={null}
      title={((title || backFn) ? <div>
        {
          backFn && <span><Button onClick={onBackPress} type="text" icon={<ArrowLeftOutlined className="gray-text" />} />&nbsp;</span>
        }
        {
          title && <strong className="gray-text">{title}</strong>
        }
      </div> : null)
      }
    >
      <Form
        form={abhaForm}
        layout="vertical"
      >
        <AbhaComponent handlers={{ form: abhaForm, goNext, setComponentNav }} isEdit={isEdit} selectedRecord={selectedRecord} />
      </Form>
    </Modal>
  );
};

export default LinkRecordsModal;
